import axios from "axios";
import { Constants } from "../Constants";

const instance = axios.create({ baseURL: Constants.BASE_URL });

export const fetchAccount = async (data: any) => {
  try {
    const httpOptions = {
      headers: {
        Authorization: data.token,
      },
    };
    return await instance.get(`/account`, httpOptions);
  } catch (error) {
    throw error;
  }
};

export const putAccount = async (data: any) => {
  try {
    const httpOptions = {
      headers: {
        Authorization: data.token,
      },
    };
    return await instance.put(`/account`, data, httpOptions);
  } catch (error) {
    throw error;
  }
};
